import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, Compass, ArrowLeft } from 'lucide-react';
import { Button } from './Button.js';
import { useI18n } from '../../context/I18nContext.js';

export function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useI18n();

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center p-6 space-y-4">
      <div className="w-16 h-16 rounded-2xl bg-indigo-500/10 flex items-center justify-center text-indigo-600 dark:text-indigo-400">
        <Compass className="w-8 h-8" />
      </div>
      <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 dark:text-slate-100">
        {t('statusPages.notFoundTitle')}
      </h1>
      <p className="text-sm text-slate-500 dark:text-slate-400 max-w-sm">
        {t('statusPages.notFoundDesc')}
      </p>
      <Button variant="primary" onClick={() => navigate('/admin')}>
        <ArrowLeft className="w-4 h-4 mr-1.5" /> {t('statusPages.returnToDashboard')}
      </Button>
    </div>
  );
}

export function ForbiddenPage() {
  const navigate = useNavigate();
  const { t } = useI18n();

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center p-6 space-y-4">
      <div className="w-16 h-16 rounded-2xl bg-rose-500/10 flex items-center justify-center text-rose-600 dark:text-rose-400">
        <ShieldAlert className="w-8 h-8" />
      </div>
      <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 dark:text-slate-100">
        {t('statusPages.forbiddenTitle')}
      </h1>
      <p className="text-sm text-slate-500 dark:text-slate-400 max-w-sm">
        {t('statusPages.forbiddenDesc')}
      </p>
      <Button variant="outline" onClick={() => navigate('/admin')}>
        <ArrowLeft className="w-4 h-4 mr-1.5" /> {t('statusPages.returnToSafety')}
      </Button>
    </div>
  );
}
